/* eslint-disable no-unused-expressions */
import { createInputHidden } from '../utils/common'
import { INPUT_HIDDEN_NAME } from '../utils/constants'
import { continentsCountries, expertises } from './listItems';
import addInputHiddenWithEmptyValue from './addInputHiddenWithEmptyValue';
import { handleDropdownItems, removePillsIfBellongToContinent } from './handleDropdownList';
import { suggestionsDropdown } from './suggestionsDropdown';


// DELETING PILLS
const removePill = (event) => {
  const isCloseBtn = event.target.className === 'profile__pills-close';
  let itemName = isCloseBtn ? event.target.parentNode.getAttribute('name') : event.target.getAttribute('name')
  let itemType = isCloseBtn ? event.target.parentNode.getAttribute('data-type') : event.target.getAttribute('data-type')
  let pillsContainer = event.target.closest('.profile__pills-container')
  addInputHiddenWithEmptyValue(null, pillsContainer);
  isCloseBtn ? event.target.parentNode.remove() : event.target.remove();
  
  if (itemType !== 'skills') {
    itemType === 'expertise'
      ? handleDropdownItems(expertises, itemName, false)
      : handleDropdownItems(continentsCountries, itemName, false)
  }
}

// Inputs where user types and create a Pill with the value & trigger the dropdown,
const pills = () => {
  const inputPills = document.querySelectorAll('.js-pills'); // Inputs where user types and create a Pill with the value
  const pills = document.querySelectorAll('.profile__pills'); // Pills

  inputPills && inputPills.forEach( input => {
    const isExpertiseInput = input.classList.contains('js-expertises');
    const isSkillsInput = input.classList.contains('js-skills');
    
    // If is not Skills create the Dropdown 
    if (!isSkillsInput) {
      const drodownListArray = isExpertiseInput ? expertises : continentsCountries
      suggestionsDropdown(input, drodownListArray);
    } else {
      input.addEventListener('keydown', () => createPills(input));
    }
  });
  
  // Adding click listener to Pills that already in the DOM
  pills.forEach( singlePill => {
    singlePill.addEventListener('click', removePill);
  });
};

const createPills = (input, isFromSuggest, suggestion) => {
  const itemName = input.value;
  const isActivityAreas = input.classList.contains('js-areas');
  let inputHiddenName = INPUT_HIDDEN_NAME.skills

  const createSinglePill = () => {
    const item = document.createElement('div');
    const close = "<span class=\'profile__pills-close\'>✕</span>";
    item.classList.add('profile__pills');
    item.setAttribute('name', itemName);
    isFromSuggest ? item.setAttribute('data-type', suggestion.type) : item.setAttribute('data-type', 'skills');
    item.innerHTML = itemName + close;
    item.addEventListener('click', removePill);
    return item;
  };

  const addPill = (input, inputHiddenName) => {
    
    /**
     * Adding Pill & Hidden Input with the selected Continent/Country,
     * Cleaning the main input value and changing the name attribute as his id attribute.
     */
    
    // Adding pill
    const getChild = child => input.closest('.afd-textfield').querySelector(child);
    getChild('.profile__pills-container').appendChild(createSinglePill());

    if (isFromSuggest) {
      const drodownListArray = suggestion.type === 'expertise' ? expertises : continentsCountries
      handleDropdownItems(drodownListArray, itemName, true)
      if (suggestion.type === 'continent') {
        inputHiddenName = INPUT_HIDDEN_NAME.continent
        getChild(`.profile__pills[name="${itemName}"]`).appendChild(createInputHidden(inputHiddenName, itemName));
        removePillsIfBellongToContinent(itemName)
      } else if (suggestion.type === 'country') {
        inputHiddenName = INPUT_HIDDEN_NAME.country
        getChild(`.profile__pills[name="${itemName}"]`).appendChild(createInputHidden(inputHiddenName, itemName));
      } else if (suggestion.type === 'expertise') {
        inputHiddenName = INPUT_HIDDEN_NAME.expertises
        getChild(`.profile__pills[name="${itemName}"]`).appendChild(createInputHidden(inputHiddenName, itemName));
      }
    } else {
      getChild(`.profile__pills[name="${itemName}"]`).appendChild(createInputHidden(inputHiddenName, itemName));
    }
    // Cleaning the input and changing the attribute name
    getChild('.js-pills').value = '';
    getChild('.js-pills').name = getChild('.js-pills').id;
  };

  if (event.key === 'Enter' && input.value != '') {
    event.preventDefault();
    if (isActivityAreas) return;
    addPill(input, inputHiddenName);
  }

  if (isFromSuggest) {
    addPill(input, inputHiddenName);
  }
};

export { pills, createPills };
